export * from "binaryen";
export { default } from "binaryen";
